import React from 'react';
import { useNavigate } from 'react-router-dom';
import UpdatePasswordForm from './UpdatePasswordForm';
import { connect } from 'react-redux';
import { editUserPassword } from '../../redux/actions/userActions';
import { Helmet } from 'react-helmet-async';
import { FormattedMessage } from 'react-intl';

export function UnconnectedExpiredPassword(props) {
  const navigate = useNavigate();
  const { currentUser } = props;
  const user = currentUser || {
    title: '',
    first_name: '',
    last_name: '',
    suffix: '',
  };

  const updatePasswordSubmit = (values) => {
    props.dispatch(editUserPassword(values, navigate, '/logout'));
  };

  return (
    <div className="container">
      <div className="layout-container">
        <div className="content-container content-container--column">
          <FormattedMessage
            id="expiredPassword.editUserTitle"
            defaultMessage="Password Update For: {userName}"
            description="The title for the page to edit a unit"
            data-test="form-header"
            values={{
              userName: `${user.title ? user.title : ''} ${
                user.first_name ? user.first_name : ''
              } ${user.last_name ? user.last_name : ''} ${
                user.suffix ? user.suffix : ''
              }`,
            }}>
            {(txt) => (
              <h1
                className="no-margin text-center"
                data-test="form-header-text">
                {txt}
              </h1>
            )}
          </FormattedMessage>
          <div>
            <FormattedMessage
              id="expiredPassword.explanationText"
              defaultMessage="Your password has expired or needs to be updated. Please enter a new password below. <b>After submitting, you will be logged out and will need to log in with your updated password.</b>"
              data-test="explanation-text"
              values={{
                b: (msg) => <span className="text-alert text-bold">{msg}</span>,
              }}
            />
          </div>
          <hr />
          <FormattedMessage
            id="expiredPassword.browserTabInfo"
            defaultMessage="Password Update: {userName}"
            description="Done button"
            values={{
              userName: `${user.title ? user.title : ''} ${
                user.first_name ? user.first_name : ''
              } ${user.last_name ? user.last_name : ''} ${
                user.suffix ? user.suffix : ''
              }`,
            }}>
            {(txt) => (
              <Helmet>
                <title>{txt}</title>
              </Helmet>
            )}
          </FormattedMessage>
          <UpdatePasswordForm
            onSubmit={updatePasswordSubmit}
            previous={'/logout'}
            data-test="update-password-form"
            user={user}
          />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.currentUser,
  };
};

export default connect(mapStateToProps)(UnconnectedExpiredPassword);
